import React, { useEffect, useRef, useState, useCallback } from "react";
import axios from "axios";
import InviteInput from "./InviteInput.jsx";
import CartItems from "./CartItems.jsx";
import CartOverView from "./CartOverView.jsx";
import { Tooltip } from 'react-tooltip'
import { ErrorBoundary } from "@sentry/react";
import * as Sentry from "@sentry/react";

import { useTranslation } from 'react-i18next';
import {
    CartAbandonedFilledIcon,
    ShareIcon
} from '@shopify/polaris-icons';
import {Icon, Link} from "@shopify/polaris";
import LeaveConfirmation from './LeaveConfirmation.jsx';

import Totals from "./Totals.jsx";
import ShareBox from "./ShareBox.jsx";
import CrewCartComplete from "./CrewCartComplete.jsx";
import Header from "./Header.jsx";
import Tabs from "./Tabs.jsx";
import Info from "./Info.jsx";
import CartButtons from "./CartButtons.jsx";


import RemovedUser from './RemovedUser';

const CartBox = Sentry.withProfiler(({ rootUrl, shop }) => {
    const [userToken, setUserToken] = useState(null);
    const { t } = useTranslation();
    const [shoppingComplete, setShoppingComplete] = useState(false);

    const [showRemovedMessage, setShowRemovedMessage] = useState(false);

    const [preloadItems, setPreloadItems]= useState([]);
    const [loading, setLoading] = useState(false);
    const [crewCart, setCrewCart] = useState({});
    const [showShare, setShowShare] = useState(false);
    const [crewcartMember, setCrewcartMember] = useState({
        id : "",
        name : "",
        status:"SIGNING_UP",
        crew_cart_id : "",
    });
    const [crewCartToken, setCrewCartToken] = useState(null);
    const [settings, setSettings] = useState({
        crewcart_token: "",
        background_color: "#ffffff",
        header_image : null,
        header_text : "Share a cart with friends, shop together, deliver to one address, and enjoy group discounts.",
        custom_css: "",
        heading: "Crewcart Heading",
        heading_color: "#ff0000",
        heading_font_size: 14,
        loadingtext: "loading..",
        button_color: "#000000",
        button_hover_color: "#CCCCCC",
        crewcart_border_radius: 0,
        crewcart_item_margin: 5,
        crewcart_item_padding: 2,
        product: "",
    });

    const [socketConnected, setSocketConnected] = useState(true);
    const reconnectTimeoutRef = useRef(null);

    // Add a new state to track initial signup
    const [isInitialSignup, setIsInitialSignup] = useState(true);



    const [currencyFormatter, setCurrencyFormatter] = useState(null);

    useEffect(() => {
        if (crewCart?.shop?.currency) {
            const formatter = new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: crewCart.shop.currency,
                minimumFractionDigits: 2,
            });
            setCurrencyFormatter(formatter);
        }
    }, [crewCart?.shop?.currency]);

    useEffect(() => {



        if(crewCart.status == "complete") {
            let domain = getDomain();
            window.parent.postMessage(
                { type: 'OPEN_CART'},
                'https://' + domain
            );
        }

        //loop over all members, and
        //we only have one member, lets show the share tab
       // if(crewCart?.members?.length == 1) {
            //setShowShare(true);
        //}
    }, [crewCart]);

    const getDomain = () =>{
        let domain =crewCart?.shop?.origin_domain;
        if(domain == null) {

            console.log("domain not set, get from the iframe url")
            //get the domain from the shop get variable
            const urlParams = new URLSearchParams(window.location.search);
            domain = urlParams.get("shop");



        }

        return domain;
    }

    // Use a ref to track if the initial token check has been done
    const initialTokenCheckDone = useRef(false);

// This effect runs first with highest priority - it only checks localStorage and URL
    useEffect(() => {
        if (initialTokenCheckDone.current) return;


        // Get URL parameters first
        const urlParams = new URLSearchParams(window.location.search);
        const paramToken = urlParams.get("token");
        const paramCrewcartToken = urlParams.get("crew_cart");
        const isNewUser = urlParams.get("new_user") === "true";
        const isReturning = urlParams.get("returning") === "true";

        // Check localStorage
        const storedUserToken = localStorage.getItem("crewCartUserId");
        const storedCrewCartToken = localStorage.getItem("crewCartToken");


        // PRIORITY 1: Use URL parameters if they exist (new join or returning user)
        if (paramToken && paramCrewcartToken) {

            setUserToken(paramToken);
            setCrewCartToken(paramCrewcartToken);

            // Save to localStorage
            localStorage.setItem('crewCartUserId', paramToken);
            localStorage.setItem('crewCartToken', paramCrewcartToken);

            // If it's a new user, show the share dialog
            if (isNewUser) {
                setIsInitialSignup(true);
            }
        }
        // PRIORITY 2: Use localStorage tokens if available
        else if (storedUserToken && storedCrewCartToken) {
            setUserToken(storedUserToken);
            setCrewCartToken(storedCrewCartToken);
        }

        initialTokenCheckDone.current = true;
    }, []); // Empty dependency array ensures this only runs once on mount

    const parentConstructCrewCart = (e) => {


        let domain = getDomain();
        window.parent.postMessage(
            { type: 'CONSTRUCT', userToken: userToken, crewCartToken: crewCartToken },
            'https://' + domain
        );
    };


    useEffect(() => {




        if(!userToken || !crewCartToken){

            return;
        }

        parentConstructCrewCart();

        getItems();


    }, [userToken, crewCartToken]);


    const handlePreloadItems = async function() {
        await addToCart(JSON.stringify(preloadItems), userToken);
        setPreloadItems([]);
    }
    const addToCart = async (data, cartToken) => {

        try {
            await axios.post(`${rootUrl}/api/crewcart/add`, {
                user_token: cartToken, // Use ref for the latest userToken
                cart_token: crewCartToken,
                data: data,
            });

            getItems();

            window.parent.postMessage(
                { type: 'OPEN_CART'},
                'https://' + crewCart?.shop?.origin_domain
            );
        } catch (err) {

            if (err.response?.data?.message === 'crewcart_closed') {
                alert(t('cartItems.crewcartClosed'));
                // Clear any local storage and reload to reset the state
                localStorage.removeItem("crewCartUserId");
                localStorage.removeItem("crewCartToken");
                window.location.reload();
            }
        }
    };



    const updateCart = async(removed, added, cartToken) => {
        try {
            await axios.post(`${rootUrl}/api/crewcart/update`, {
                user_token: cartToken, // Use ref for the latest userToken
                cart_token: crewCartToken,
                removed: removed,
                added: added
            });

            getItems();

            window.parent.postMessage(
                { type: 'OPEN_CART'},
                'https://' + crewCart?.shop?.origin_domain
            );
        } catch (err) {
            console.log(err.message);
        }
    }
    const resizeIframe = function() {
         window.parent.postMessage(
             { type: 'RESIZE', height: document.body.scrollHeight + 150},
             'https://' + crewCart?.shop?.domain
         );
    }

    useEffect(()=>{
      resizeIframe();
    }, [showShare]);
    const getItems = async () => {
        setLoading(true);
        try {

            const res = await axios.post(`${rootUrl}/api/crewcart`, {
                crew_cart_token: crewCartToken,
            });
            setLoading(false);


                setCrewCart(res.data);

        } catch (err) {
            setLoading(false);
            console.error("Error fetching cart items:", err.message);
        }
    };


    useEffect(() => {
        if (crewCart?.members && crewcartMember?.id) {
            const currentMember = crewCart.members.find(
                member => member.id === crewcartMember.id
            );


            setShowRemovedMessage(!currentMember);
        }
    }, [crewCart?.members]);

    useEffect(() => {

        if(!crewCartToken) { return; }

        getItems();
        getUser();

    }, [crewCartToken]);


    const [confirmLeave, setConfirmLeave] = useState(false); // State to manage leave confirmation
    const confirmationTimeoutRef = useRef(null); // Ref to store the timeout ID

    const cancelLeave = async() => {
        setConfirmLeave(false);
    }
    const leaveCrewcart = async () => {
        if (!confirmLeave && crewCart.status == "open") {
            setConfirmLeave(true);
            return;
        }

        try {
            await axios.post(`${rootUrl}/api/crewcart/leave`, {
                user_token: userToken,
                cart_token: crewCartToken,
            });

            clearSession();

            window.parent.postMessage(
                {type: 'UNSUBSCRIBE_USER'},
                'https://' + crewCart?.shop?.origin_domain
            );

            window.location.reload();
        } catch (err) {
            console.log(err.message);
        } finally {
            setConfirmLeave(false);
        }
    };

    useEffect(() => {
        // Cleanup timeout on unmount
        return () => {
            clearTimeout(confirmationTimeoutRef.current);
        };
    }, []);



    const getUser = async () => {

        try {
            const res = await axios.post(`${rootUrl}/api/crewcart/member`, {
                crew_cart_token: crewCartToken,
                user_token: userToken
            });

            if(res?.data?.token) {


                setUserToken(res.data.token);

                localStorage.setItem("crewCartUserId", res.data.token);
                let domain = getDomain();

                window.parent.postMessage(
                    { type: 'USER_TOKEN', userToken: res.data.token},
                    'https://' + domain
                );


                window.parent.postMessage(
                    { type: 'OPEN_CART'},
                    'https://' + domain
                );
            }
            if (res.status == 200) {
                setCrewcartMember({
                    id: res.data.id,
                    name: res.data.name,
                    crew_cart_id:  res.data.crew_cart_id,
                    status : res.data.status
                });
            }
        } catch (err) {
            console.log(err.message);
          //  localStorage.removeItem("crewCartUserId");
            //localStorage.removeItem("crewCartToken");

        }
    }

    useEffect(() => {
        if (preloadItems.length > 0) {
            handlePreloadItems();
        }
    }, [preloadItems]); // This will run whenever preloadItems changes




    // Modify your connectWebSocket function to detect connection issues
    const connectWebSocket = useCallback((crewcartMember) => {
        if (!crewcartMember?.crew_cart_id) return;

        try {
            window.Echo.channel(`crewcart.${crewcartMember.crew_cart_id}`)
                .listen('CrewCartUpdateEvent', async (e) => {
                    if (e?.crewcart) {
                        // Transform the minimal data back into a format compatible with your frontend
                        const updatedCart = {
                            ...crewCart, // Keep existing data
                            ...e.crewcart, // Override with new data
                            members: e.crewcart.members,
                            items: e.crewcart.items,
                        };
                        setCrewCart(updatedCart);
                    }

                    resizeIframe();

                    if (e?.message?.update != crewcartMember.id && e?.message?.event != 'total_update') {
                        window.parent.postMessage(
                            {type: 'NOTIFICATION'},
                            'https://' + crewCart?.shop?.origin_domain
                        );
                    }
                })
                .error((error) => {
                    console.error("Socket connection error:", error);
                    setSocketConnected(false);
                });

            window.Echo.channel('channel_for_everyone')
                .listen('GotMessage', async (e) => {

                })
                .error((error) => {
                    console.error("Socket connection error for everyone channel:", error);
                    setSocketConnected(false);
                });

            // Set connected state when successfully connected
            setSocketConnected(true);
        } catch (error) {
            console.error("Error establishing WebSocket connection:", error);
            setSocketConnected(false);
        }



    }, [crewCart?.shop?.origin_domain, resizeIframe]);

    useEffect(() => {

        if(!crewCartToken || !crewcartMember.id) return;
        //getMessages();
        connectWebSocket(crewcartMember);

        // return () => {
        //     window.Echo.leave("refresh-cart");
        //     window.Echo.leave(`crewcart.${crewcartMember.crew_cart_id}`);
        //     window.Echo.leave('channel_for_everyone');
        // }
    }, [crewCartToken, crewcartMember, connectWebSocket]);

    // This function attempts to reconnect the WebSocket
    const reconnectWebSocket = useCallback(() => {


        if (!crewcartMember?.crew_cart_id) return;

        // Clear any existing Echo channel subscription
        if (window.Echo) {
            window.Echo.leave(`crewcart.${crewcartMember.crew_cart_id}`);
            window.Echo.leave('channel_for_everyone');
        }

        // Attempt to reconnect
        connectWebSocket(crewcartMember);

        // Fetch latest data to ensure we're in sync
        getItems();

        setSocketConnected(true);
    }, [crewcartMember, connectWebSocket, getItems]);


    useEffect(() => {

        let domain = getDomain();


        window.parent.postMessage(
            { type: 'GET_SETTINGS'},
            'https://' + domain
        );
    }, []);

    // Add listeners for visibility and online/offline events
    useEffect(() => {
        // Handler for when the page becomes visible again (e.g., after phone unlock)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {

                // Check if Echo is defined and if we are connected
                if (window.Echo && !socketConnected) {
                    reconnectWebSocket();
                }
            }
        };

        // Handler for when the device goes online
        const handleOnline = () => {
            console.log("Device is online, reconnecting socket...");
            reconnectWebSocket();
        };



        // Handler for when the device goes offline
        const handleOffline = () => {
            console.log("Device is offline, socket connection lost");
            setSocketConnected(false);
        };

        // Add event listeners
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Set up a periodic connection check (every 30 seconds)
        const checkConnectionInterval = setInterval(() => {
            if (window.Echo && crewcartMember?.crew_cart_id) {
                // A simple ping to check if the connection is alive
                // You may need to adjust this based on your Echo/Laravel implementation
                if (!socketConnected) {
                    console.log("Periodic check: socket disconnected, attempting reconnect");
                    reconnectWebSocket();
                }
            }
        }, 30000);
        // Clean up on component unmount
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            clearInterval(checkConnectionInterval);

            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
            }

            if (window.Echo && crewcartMember?.crew_cart_id) {
                // window.Echo.leave(`crewcart.${crewcartMember.crew_cart_id}`);
                // window.Echo.leave('channel_for_everyone');
            }
        };
    }, [crewcartMember?.crew_cart_id, socketConnected, reconnectWebSocket]);

    useEffect(() => {
        // Listen for messages from the parent site

        const handleMessage = (event) => {

            let domain = getDomain();
            if (event.origin !== "https://" + domain && event.data.type != "CART_ITEMS") return;


            if (event.data.type === "ADD_TO_CART") {
                addToCart(event.data.data, userToken);
            }
            if(event.data.type === "CART_ITEMS") {
                //we seem to already have items in the cart
                let items = event.data.cart_items;
                if(items.length > 0) {
                    try {
                        setPreloadItems(items);
                    }catch(err) {
                        console.log(err);
                    }
                }
            }
            if (event.data.type === "UPDATE_CART") {
                updateCart(event.data.removed, event.data.added, userToken);
            }

            if (event.data.type === "INIT") {
                setUserToken(event.data.cart_token);
                setSettings(JSON.parse(event.data.settings));

            }

            if (event.data.type === "SETTINGS") {

                setSettings(JSON.parse(event.data.settings));
            }
        };
        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);


            if (window.Echo && crewcartMember?.crew_cart_id) {
                // window.Echo.leave(`crewcart.${crewcartMember.crew_cart_id}`);
                // window.Echo.leave('channel_for_everyone');
            }

        };
    }, [userToken, crewCart, crewcartMember?.crew_cart_id, socketConnected, reconnectWebSocket]);


    const [activeTab, setActiveTab] = useState("crewcart");
    const handleLinkClick = (tab) => {
        setActiveTab(tab);
    };


    useEffect(() => {
        if(crewcartMember) {
            let member = crewCart?.members?.find(member => member.id == crewcartMember.id);

            if(member) {
                setCrewcartMember({
                    id: member.id,
                    name: member.name,
                    crew_cart_id:  member.crew_cart_id,
                    status : member.status
                });
            }
        }
    }, [crewCart]);
    useEffect(() => {
        if (crewCart?.id && userToken) {
            Sentry.setContext("cart", {
                cartId: crewCart.id,
                memberCount: crewCart.members?.length,
                status: crewCart.status
            });

            Sentry.setUser({
                id: userToken,
                isMember: !!crewcartMember.id
            });
        }
    }, [crewCart, userToken, crewcartMember]);

    useEffect(() => {
        if (crewcartMember?.name && isInitialSignup) {
            const hasSeenShare = localStorage.getItem('hasSeenShare');
            if (!hasSeenShare) {
                setShowShare(true);
                localStorage.setItem('hasSeenShare', 'true');
                setIsInitialSignup(false);
            }
        }
    }, [crewcartMember?.name]);

    // Add a function to handle session cleanup
    const clearSession = useCallback(() => {
        // Clear localStorage
        localStorage.removeItem("crewCartUserId");
        localStorage.removeItem("crewCartToken");
        localStorage.removeItem('hasSeenShare');

        // Reset states
        setUserToken(null);
        setCrewCartToken(null);
        setCrewCart({});
        setCrewcartMember({
            id: "",
            name: "",
            crew_cart_id: "",
        });
    }, []);

    return (
        <div className="row">
            <ErrorBoundary fallback={<p>An error has occurred</p>}>
            <style>
                {`
                .crew-cart-items{
                overflow-y: scroll;
                padding:5px;
                }
                .subtext{
                color: #999;
                font-size:.9em;
                text-align: left;
                }
                .crew-cart-checkout{
                padding:0 10px;
                  flex: 1; /* Take up all available space */

                padding: 10px;
    overflow-y: auto;
               }
               .checkout-button-container {
    padding: 10px 0;
    background: #fff;
    border-top: 1px solid #eee;
    bottom: 30px;
    position: sticky;
    width: 100%;
    margin-top: auto;
    text-align: center;
    left: 0;
}
.checkout-button-container.confirm{
position:absolute;
bottom:unset;
top:0;
border-top:0;
height:100%;
}
.confirm-remove-pending-users{
position:absolute;
height: calc(100dvh - env(safe-area-inset-bottom));
z-index:709;
background-color:#fff;
width:100%;
}

.checkout-button-container button:hover {
   background-color: #333;
}
.checkout-button-container button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    border:none;
}
               .crew-cart-checkout button{
               background-color: #000;
               border:0;
               padding:10px;
               }
               .done-shopping{
                background-color: #000;
                border:0;
                color:#fff;
               }

               .crew-cart-checkout button:hover, .done-shopping:hover{
               background-color: #333;
               color:#fff;
               }
                .bottom-border{
                    border-bottom:1px solid #eee;
                    width:100%;
                    margin-bottom:10px;
                }
                .card {
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    margin-top: 20px;
                }
                .bottomBorder{
                    border-bottom: 1px solid #eee;
                }
                .crew-cart-members{
                    display:flex;
                    gap:5px;

                }
                .crew-cart-members span{

                }
                .cartBox .card{
                border-radius:10px;
                margin-top:0;
                background-color:#fff;
                }
                .flex-column{
                padding:1px;
                }
                .cartBox {
                font-family :"Open Sans", -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
                    display: flex;
  flex-direction: column;
    height: 100%; /* Ensure the parent takes the full height */
    position: relative;

                }

              .qtyBtn {
    background-color: #ffffff;
    background: #ffffff;
    border: 1px solid #ccc;
    padding: 3px;
    font-size:1.3em;
   height:25px;
    width: 28px;
    cursor: pointer; /* Add this to indicate interactivity */
}
.remove-item{
    cursor:pointer;
}
.more-info{
color:#959595;
cursor:pointer;
display:block;
margin: 10px 0;
}

  .qtyBtn:disabled:hover {
    opacity: 0.3;

  }
  .create-form input[type="text"], .create-form input[type="email"]{
  border:0;
  border-bottom:1px solid #000;
  display:block;
  width:100%;
  background:#fff;
  border-radius:0;
  margin-bottom:25px;
  }
.qtyBtn:hover {
    background: #000000;
    background-color: #000000;
    color: #ffffff; /* Optional: change text color on hover for better contrast */
}
.cart-item{
margin: 5px 0;
padding:10px;
}

.h3-title-invite{
padding:10px;
font-weight:bold;
}

.crew-cart-members{
   padding-left: 5px;
    padding-bottom: 5px;
    display: flex;
    align-items: center; /* Vertically centers the content */
    justify-content: center; /* Horizontally centers the content */
    text-align: center; /* Ensures text alignment within the container */
}
.crew-cart-members li{
tex-decoration:none;
list-style-type:none;
padding:3px 10px;
border-radius:10px;
font-size:.8em;
margin-top:10px;
justify-content: between;
}
.btn-shop{
font-weight:bold;
cursor:pointer;
height:50px;
display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  font-size:1.1em;
  cursor:pointer !important;
}
.btn-primary-crewcart{
width:100%;
display:block;
background:#000 !important;
color:#fff !important;
height:35px;
font-weight:bold;
border-radius:0;
}
.btn-crewcart-checkout{
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    }
.crew-cart-tabs a[aria-disabled=true]{
opacity:.5;
}
.crew-cart-tabs a{
opacity:.5;
}
.crew-cart-tabs a:hover{
opacity:1;
}
.crew-cart-tabs a.active{
opacity:1;
}
.btn-primary-crewcart .Polaris-Icon {
width:20px;
height:27
px;
display:inline-block;
fill: #fff;
}
.status-circle {
    width: 10px; /* Size of the circle */
    height: 10px;
    border-radius: 50%; /* Makes it a perfect circle */
    display: inline-block; /* Ensures it stays inline */
    background-color: gray; /* Default color */
    border: 1px solid #eee; /* Optional border */
}

/* Color variations based on data-status attribute */
.status-circle[data-status="SHOPPING"] {
    background-color: orange; /* Yellow for browsing */
}

.status-circle[data-status="DONE"] {
    background-color: green; /* Green for done */
}

.status-circle[data-status="IDLE"] {
    background-color: red; /* Red for idle */
}
.btn-primary{
width: 135px;
height: 45px;
border:0;
}
.preload-message .crew-cart-checkout{
width:100%;
}
.preload-message .btn-primary{
background:#000;
color:#fff;
}
.preload-message {
  position: absolute;
  z-index: 1000;
  background-color: #fff;
  height: 630px;
  width: 96%;
  top:20px;
  left:15px;
  display: flex;
  flex-direction: column; /* Stack children vertically */
  align-items: center; /* Center content horizontally */
  text-align: center; /* Ensure text is centered */
  gap: 2rem; /* Space between text and button container */
  padding:0;
}
.button-container {
  display: flex; /* Align buttons next to each other */
  gap: 1rem; /* Space between buttons */
}

.crewcart-logo-black{
margin-bottom:10px;
}
.crew-cart-overview {
    width: 100%;
}
.crew-cart-members li{
cursor: pointer;
}


.copy-button{
width:85px;
border:0;
background-color:#000;
}
.copy-button:hover{
background-color:#333;
}
.top-icons .Polaris-Icon{
width:20px;
}
.h3-title-invite{
position:relative;
margin-bottom:10px;
}

#crewcart-totals{
position:sticky;
bottom:100px;
background:#fff;
}
#checkout-button-container{
position:sticky;
bottom:0;
background:#fff;
}
.card {
    display: flex;
    flex-direction: column;
    height: calc(100dvh - env(safe-area-inset-bottom));
max-height:660px;
    overflow: hidden;
}

.flex-1 {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    position: relative;
    /* Force scrollbar to always show to prevent layout shift */
    overflow-y: scroll;
    scrollbar-gutter: stable;
}

.sticky-tabs {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 100;
    width: 100%;
    margin-top:auto;
    /* Ensure consistent width regardless of scrollbar */
}

/* Ensure content area takes remaining space but allows scrolling */
.crew-cart-items, .info-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}

/* Style scrollbar for better appearance */
.flex-1::-webkit-scrollbar {
    width: 8px;
}

.flex-1::-webkit-scrollbar-track {
    background: transparent;
}

.flex-1::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

@media (max-width: 468px) {
    #app {
    margin-top:30px;
        padding: 0;
        width: 100vw;
        max-width: 100vw;
        overflow-x: hidden;
    }

    .row {
        margin: 0;
        padding: 0;
        width: 100vw;
        max-width: 100vw;
    }

    .cartBox {
        height: calc(100dvh - 25px - env(safe-area-inset-bottom));
        padding: 0 !important;
        width: 100vw;
        max-width: 100vw;
        overflow-x: hidden;
    }

    .card {
        margin: 0;
        border-radius: 0;
        width: 100vw;
        max-width: 100vw;
        max-height:none;
    }

    .crew-cart-items {
        max-height: none;
        overflow-y: visible;
        padding: 5px;
        width: 100%;
    }
}

.crew-cart-items {
    flex: 1;
    overflow-y: auto;
    padding: 5px;
}
#app button:hover{
 opacity:.75;
}

                `}
            </style>



            {confirmLeave && (
                <LeaveConfirmation
                    onConfirm={leaveCrewcart}
                    onCancel={cancelLeave}
                />
            )}
            {crewCart?.status == "complete" &&
                <CrewCartComplete rootUrl={rootUrl} loading={loading} setLoading={setLoading} currencyFormatter={currencyFormatter} crewCart={crewCart} resizeIframe={resizeIframe} />
            }
            <div className="col-md-8 p-3 pt-0 cartBox">


            <div className="card card relative flex flex-col h-full">
                    <div className="flex-none px-3 pt-3">
                        <Header crewCart={crewCart}/>
                    </div>
                {showRemovedMessage && crewcartMember?.name && crewcartMember.name !="" && crewcartMember?.status !="SIGNING_UP" ? (
                    <RemovedUser crewCart={crewCart} />
                ) : (
                <div className="flex-1 overflow-y-auto px-3 pb-16">

                    {crewCart?.id && crewcartMember.name &&
                        <div className={"title-container"} style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%'
                        }}>
                            <h3 className="h3-title-invite" style={{margin: 0}}>
                                {crewCart?.name ? crewCart.name : ''}
                            </h3>
                            <div className={"top-icons"} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                    <span
                                        onClick={leaveCrewcart}
                                        aria-disabled={shoppingComplete || crewCart?.status != "open"}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            cursor: 'pointer',
                                        }}
                                    >{t('cartItems.leave')} <Icon source={CartAbandonedFilledIcon}/>
                                </span>

                                <div style={{
                                    width: '1px',
                                    height: '20px',
                                    backgroundColor: '#000',
                                    opacity: 0.3
                                }}/>

                                <Tooltip id={"share-crewcart"} style={{fontSize: ".6em"}}/>
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (crewCart?.status == "open") {
                                            setShowShare(prevState => !prevState);
                                        }
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        cursor: 'pointer',
                                        fontWeight: showShare ? 'bold' : 'normal'
                                    }}
                                    data-tooltip-id={"share-crewcart"}
                                    data-tooltip-content={t('cartItems.shareCrewcart')}
                                    aria-disabled={crewCart?.status != "open"}
                                >{t('cartItems.share')} <Icon source={ShareIcon}/></span>
                            </div>
                        </div>}
                    {showShare && userToken && crewcartMember.name &&
                        <ShareBox setShowShare={setShowShare} shopDomain={shop} crewCartToken={crewCartToken}
                                  crewCart={crewCart}/>}



                    {!userToken && activeTab != "info" && (
                        <>
                            {settings.header_image && (
                                <div className="header-image">
                                    <img src={settings.header_image} width={"100%"} />
                                </div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: settings.header_text || t('header.text') }} />
                        </>
                    )}
                    {!userToken && activeTab != "info" &&
                        <a className="more-info" onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick("info");
                            resizeIframe();
                        }} href={"#"} target={"_blank"}>{t('createCrewcart.learnMore')}</a>}
                    <div>
                        {activeTab === "crewcart" && userToken && crewcartMember.name && (
                            <div>
                                {crewCartToken && crewCart && userToken && crewcartMember.name &&
                                    <><CartItems loading={loading} rootUrl={rootUrl} crewcart={crewCart}
                                                 currencyFormatter={currencyFormatter}
                                                 shoppingComplete={crewcartMember?.status === "DONE"}
                                                 crewCartToken={crewCartToken}
                                                 userToken={userToken} settings={settings}
                                                 member={crewcartMember}/>
                                    </>
                                }
                            </div>

                        )}


                        {activeTab === "info" && (
                            <Info/>
                        )}


                    </div>
                    {activeTab === "cart-overview" && (
                        <CartOverView rootUrl={rootUrl} crewCart={crewCart} currencyFormatter={currencyFormatter} loading={loading}
                                      userToken={userToken}
                                      resizeIframe={resizeIframe}
                                      crewCartToken={crewCartToken} crewcartMember={crewcartMember}/>
                    )}
                    {activeTab != "info" &&
                        <InviteInput
                            shop={shop}
                            settings={settings}
                            crewCart={crewCart}
                            setParentCrewCartToken={setCrewCartToken}
                            userToken={userToken}
                            setUserToken={setUserToken}
                            rootUrl={rootUrl}
                            crewcartMember={crewcartMember}
                            setCrewcartMember={setCrewcartMember}
                            crewCartToken={crewCartToken}
                            setCrewCartToken={setCrewCartToken}
                        />}

                    <div id={"crewcart-totals"}>
                        {crewCart.status == "open" && activeTab === "crewcart" && userToken && crewcartMember.name && preloadItems.length <= 0 && (
                            <div>




                            </div>)}


                    </div>

                    {crewcartMember?.name && (activeTab === "crewcart" || activeTab === "cart-overview") &&
                        <CartButtons
                            crewcartMember={crewcartMember}
                            rootUrl={rootUrl}
                            userToken={userToken}
                            handleLinkClick={handleLinkClick}
                            crewCartToken={crewCartToken}
                            crewCart={crewCart}
                            currencyFormatter={currencyFormatter}
                        />}


                    <div className="sticky-tabs">

                        <Tabs hasName={crewcartMember?.name} handleLinkClick={handleLinkClick}
                              activeTab={activeTab}
                              shoppingComplete={shoppingComplete} resizeIframe={resizeIframe}/>
                    </div>
                </div>)}
            </div>

            </div>
            </ErrorBoundary>
        </div>
    )
        ;
});

export default CartBox;
